import Sentry from "@similarweb/sentry-logger";

import { DefaultFetchService } from "app/services/fetchService";

import type { SolutionType } from "../types";

const fetchService = DefaultFetchService.getInstance();
const SWITCH_SOLUTION_API_ENDPOINT = "/api/account/switch-trial-solution";

export interface ISwitchSolutionRequest {
    solutionType: SolutionType;
}

export const changeSolutionApiService = {
    switchSolution: async (solutionType: SolutionType): Promise<void> => {
        try {
            await fetchService.post<ISwitchSolutionRequest>(SWITCH_SOLUTION_API_ENDPOINT, {
                solutionName: solutionType,
            });
        } catch (error) {
            Sentry.errorTracker({
                message: "Error switching solution",
                e: error,
                level: "error",
                params: {
                    extra: {
                        solutionType,
                        endpoint: SWITCH_SOLUTION_API_ENDPOINT,
                    },
                },
            });
            throw error;
        }
    },
};
